import { defaultIssueFilterProps } from "@components/issues-filter-drawer/IssueFilterDrawer";
import useHasPermission from "@hooks/useHasPermission";
import { useGetTaxonomiesQuery } from "@mwServices/Taxonomy";
import { Button, Checkbox, Col, Collapse, DatePicker, Drawer, Row, Spin } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const PostsFiltersDrawer = ({
    visible, onClose, filters, onDrawerSearch
}: any) => {
    const isAdmin = useHasPermission('admin');

    const [datesVals, setDates]: any = useState(filters?.dates || []);

    const [tagVals, setTags] = useState(
        Array.isArray(filters.terms)
            ? filters.terms
            : [filters.terms]
    );

    const [catVals, setCats] = useState(
        Array.isArray(filters.terms)
            ? filters.terms
            : [filters.terms]
    );

    const tags = useGetTaxonomiesQuery({
        type: 'post',
        taxonomy: 'post_tag',
        perPage: -1,
        page: 1
    });

    const categories = useGetTaxonomiesQuery({
        type: 'post',
        taxonomy: 'category',
        perPage: -1,
        page: 1,
    });

    useEffect(() => {
        if (categories.isSuccess && tags.isSuccess) {
            const tagIntersection = findIntersection(
                Array.isArray(filters.terms)
                    ? filters.terms
                    : [filters.terms],
                tags.data.results
                    ?.map((m) => m.id)
            );

            const catIntersection = findIntersection(
                Array.isArray(filters.terms)
                    ? filters.terms
                    : [filters.terms],
                categories.data.results
                    ?.map((m) => m.id)
            );

            setCats(catIntersection);
            setTags(tagIntersection);
        }

    }, [categories, tags, filters.terms])


    const onCatChange = (vals: any[]) => {
        setCats(vals);
    }

    const onTagChange = (vals: any[]) => {
        setTags(vals);
    }

    const onDateChange = (date, dateString, info) => {
        const [start, end] = date ?? [];
        const dates: any = (start && end)
            ? [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
            : null;

        if (start && end) {
            setDates(dates);
        }
    }

    const onHandleSearch = (e) => {
        onDrawerSearch(e, {
            dates: datesVals,
            categories: catVals,
            tags: tagVals,
        });
    };

    const setDateRangeValues: any = (dates: any) => {
        const [start, end] = dates
        return dates.length > 0
            ? [
                moment(start),
                moment(end),
            ]
            : []
    };

    function findIntersection(array1, array2) {
        return array1.filter((value) => array2.includes(value));
    }

    return (
        <Drawer
            className="posts-filter-drawer"
            title="Filters"
            headerStyle={{ paddingTop: isAdmin ? 50 : 0 }}
            open={visible}
            onClose={onClose}
            footer={
                <Row justify="center">
                    <Col >
                        <Button
                            className="outlineButton thickButton"
                            style={{ width: 250 }}
                            onClick={onHandleSearch}
                        >SEARCH</Button>
                    </Col>
                </Row>
            }

        >
            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Filter by:</div>
            <Collapse className="filtersAccordion" ghost defaultActiveKey={[1, 2, 3]} expandIconPosition={"end"}>
                <Panel header="Date" key={1}>
                    <RangePicker
                        defaultPickerValue={setDateRangeValues(datesVals)}
                        defaultValue={setDateRangeValues(datesVals)}
                        onCalendarChange={onDateChange}
                        size={`middle`}
                        value={setDateRangeValues(datesVals)}
                    />
                </Panel>
                <Panel header="Category" key={2}>
                    <Spin size="small" spinning={categories.isLoading}>
                        {categories?.data &&
                            <Checkbox.Group
                                name="category"
                                defaultValue={filters.terms}
                                value={catVals}
                                options={categories.data.options}
                                onChange={onCatChange}
                            />}
                    </Spin>
                </Panel>
                <Panel header="Tags" key={3}>
                    <Spin size="small" spinning={tags.isLoading}>
                        {tags?.data &&
                            <Checkbox.Group
                                name="post_tag"
                                defaultValue={filters.terms}
                                value={tagVals}
                                options={tags.data.options}
                                onChange={onTagChange}
                            />}
                    </Spin>
                </Panel>
            </Collapse>
        </Drawer >
    );
};

PostsFiltersDrawer.defaultProps = defaultIssueFilterProps;

export default PostsFiltersDrawer;